import { BORDER_RADIUS, COLORS, SPACING } from '@monthio/design-system'
import styled from 'styled-components'

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 8px;
	gap: ${SPACING.xs};
	width: 100%;
	box-sizing: border-box;
	border-radius: ${BORDER_RADIUS.xs};
	border: 1px solid ${COLORS.graphics.stroke.primary};
	background: ${COLORS.graphics.surface.cardPrimary};
`

export const InputRowContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`
